module.exports = __webpack_public_path__ + "img/ma280.12ef0432.png";